import React from 'react'
import { FormikProps } from 'formik'
import { ToggleSwitch } from 'bs-unified-ui'

interface ToggleSwitchProps {
  field: {
    name: string
    value: any
  }
  form: FormikProps<any>
  disabled?: boolean
  [key: string]: any
}

const Switch: React.FC<ToggleSwitchProps> = ({
  field,
  form,
  disabled = false,
  ...props
}) => (
  <ToggleSwitch
    id="my-account__2fa"
    name={field.name}
    checked={field.value}
    onChange={(e: any) => {
      if (e.target.checked) {
        form.setFieldValue(field.name, e.target.checked)
      } else {
        form.setFieldValue(field.name, e.target.checked)
      }
    }}
    {...props}
    disabled={disabled || !!form.values.__readOnly}
  />
)

export default Switch
